module.exports = __webpack_public_path__ + "img/logo.879a0970.png";